// NPM
import React, { useState, useEffect } from "react";
import _ from "lodash";

// State
import { useSelector } from "react-redux";

// api
import api from "./api";

// Services
import renderService from "services/renderService";
import embedService from "services/embedService";

// Constants
const rowsToShow = 10;

function Changelog() {
  // State
  const [changelogData, setChangelogData] = useState([]);
  const [showingAll, setShowingAll] = useState(false);
  const campaignConfig = useSelector((state) => state.campaignConfig.value);
  const parties = useSelector((state) => state.parties.value);

  const loadData = async () => {
    const changelogData = await api.loadChangelog();
    setChangelogData(changelogData);
  };

  // Hooks
  useEffect(() => loadData(), []);
  useEffect(embedService.postHeight, [showingAll]);

  if (!renderService.canRender([campaignConfig, changelogData, parties])) {
    return null;
  }

  const showAllText = _.get(campaignConfig, "sections.Changelog.showAllText");
  const showLessText = _.get(campaignConfig, "sections.Changelog.showLessText");

  function renderTable() {
    const headers = changelogData[0];
    const visibleChangelogData = changelogData.slice(
      1,
      showingAll ? -1 : rowsToShow,
    );

    return (
      <table className="table Changelog__table">
        <thead>
          <tr>
            {headers.map((header, headerIndex) => {
              let party = parties.find((p) => p.id === header);
              let styles = {};
              let className = "";

              if (party) {
                styles["color"] = party.color;
                className = "is-party-value";
              }
              return (
                <th
                  key={`Changelog-header-${headerIndex}`}
                  style={styles}
                  className={className}
                >
                  {header}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {visibleChangelogData.map((row, rowIndex) => {
            return (
              <tr key={`Changelog-row-${rowIndex}`}>
                {row.map((columnValue, columnIndex) => {
                  if (columnIndex === 0) {
                    return (
                      <th
                        key={`Changelog-row-${rowIndex}-column-${columnIndex}`}
                      >
                        {columnValue}
                      </th>
                    );
                  } else {
                    let headerValue = headers[columnIndex];
                    let party = parties.find((p) => p.id === headerValue);
                    let styles = {};
                    let className = "";

                    if (party) {
                      styles["color"] = party.color;
                      className = "is-party-value";
                    }

                    return (
                      <td
                        key={`Changelog-row-${rowIndex}-column-${columnIndex}`}
                        style={styles}
                        className={className}
                      >
                        {columnValue}
                      </td>
                    );
                  }
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  const title = _.get(campaignConfig, "sections.Changelog.title");
  const description = _.get(campaignConfig, "sections.Changelog.description");

  return (
    <div id="Changelog" className="Changelog Signal__section">
      <h2 className="Signal__section-title">{title}</h2>
      <p className="Signal__section-description">{description}</p>

      <div className="Changelog__table-container table-container Signal__section-visualization">
        {renderTable()}
      </div>

      <div className="ShowMore">
        <button
          className="button is-rounded"
          onClick={() => setShowingAll(!showingAll)}
        >
          {showingAll ? showLessText : showAllText}
        </button>
      </div>
    </div>
  );
}

export default Changelog;
